import { render } from "./listopen.vue?vue&type=template&id=19bc836a&scoped=true"
import script from "./listopen.vue?vue&type=script&lang=js"
export * from "./listopen.vue?vue&type=script&lang=js"

import "./listopen.vue?vue&type=style&index=0&id=19bc836a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bc836a"]])

export default __exports__